module.exports = __webpack_public_path__ + "img/mastecard-maestro@compress-h371.1a36c914.png";